/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import {
  TableUnit,
  TableHead,
  TableSubHeader,
  TableHeader,
  TableTopHeader,
  TableTopHeaderSub,
  TableBody,
  TableRow,
  SortPopUp,
  ArrowUp,
  RadiosContainer,
  CheckBoxWrapper,
  PopUpText,
  TableColumn,
  ColumnContainerSummary,
  ArrowHolderSummary,
  StickyTableHeadDate,
} from './styles';
import { Radio, InputCheckbox } from '..';
import Utils, { deepGet } from '../../utils/api/Utils';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import getFatigueZoneBullet from '../../utils/hooks/fatigue-zone-bullet';
import { GoChevronDown, GoChevronUp } from 'react-icons/go';
import TooltipFatigueZones from '../TooltipFatigueZones/TooltipFatigueZones';
import { ArmRecovery, ArmStrength, ShoulderBalance, StrengthVelocityRatio } from '../../utils/constants/fatigueZonesInfo';
import { Oval } from '../../pages/players/styles';
import { handleDate } from '../../utils/helpers/handleDate';

function PopUp({
  table,
  useTable,
  data,
  visible,
  popup_id,
  includeAlerts,
  status,
  medical,
}: {
  table: Array<any>;
  useTable: any;
  data: Array<string>;
  visible: string;
  popup_id: string;
  includeAlerts?: boolean;
  status?: Array<string>;
  medical?: boolean;
}) {
  const [reverse, useReverse] = useState<boolean>(true);
  const UTILS = new Utils();
  const sortOptions = [reverse, useTable, table];
  const [firstRender, useFirstRender] = useState<boolean>(true);
  const [radio, useRadio] = useState<any>({ one: false, two: false });
  const [check, useCheck] = useState<any>({ zone_1: false, zone_2: false, zone_3: false });

  useEffect(() => {
    if (!firstRender) {
      UTILS.HandleSorted(data, sortOptions);
    } else {
      useFirstRender(!firstRender);
    }
    if (status) buildFilter();
  }, [radio]);

  useEffect(() => {
    if (status) buildFilter();
  }, [check]);

  function buildFilter() {
    let filters: Array<string> = [];
    Object.values(check).map((item, idx) => {
      if (item) {
        filters.push(Object.keys(check)[idx]);
      }
      return item;
    });
    filters = filters.map(item => {
      if (item === 'zone_1') {
        item = 'zone 1';
      }
      if (item === 'zone_2') {
        item = 'zone 2';
      }
      if (item === 'zone_3') {
        item = 'zone 3';
      }
      return item;
    });

    useTable(
      table.filter(item => {
        let pass = false;
        const statusValue = filters.map(filterValue => {
          return deepGet(item, status) === filterValue;
        });
        statusValue.map(val => {
          if (val) {
            pass = true;
          }
          return val;
        });
        if (filters.length === 0) {
          pass = true;
        }

        return pass;
      }),
    );
  }

  function HandleRadioSort(e: any): void {
    if (e.target.id === 'descendent') {
      const descendent = { one: true, two: false };
      useReverse(false);
      useRadio(descendent);
    } else if (e.target.id === 'ascendent') {
      const ascendent = { one: false, two: true };
      useReverse(true);
      useRadio(ascendent);
    }
  }

  if (visible === popup_id) {
    return (
      <SortPopUp>
        <ArrowUp />
        <RadiosContainer onChange={HandleRadioSort}>
          <Radio title="High-Low" name="tableInfo" id="descendent" checked={false} dynamicActive={radio.one} size={'21px'} />
          <Radio title="Low-High" name="tableInfo" id="ascendent" checked={false} dynamicActive={radio.two} size={'21px'} />
        </RadiosContainer>
        {includeAlerts && (
          <>
            <hr style={{ border: '0.5px solid rgba(240, 240, 240, 1)', marginBottom: '12px' }} />
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_1} onClick={() => useCheck({ ...check, zone_1: !check.zone_1 })} />
              <PopUpText onClick={() => useCheck({ ...check, zone_1: !check.zone_1 })}>Watch</PopUpText>
              <Oval size={'16'} color={'watch'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_2} onClick={() => useCheck({ ...check, zone_2: !check.zone_2 })} />
              <PopUpText onClick={() => useCheck({ ...check, zone_2: !check.zone_2 })}>Warning</PopUpText>
              <Oval size={'16'} color={'warning'} />
            </CheckBoxWrapper>
            {medical && (
              <CheckBoxWrapper>
                <InputCheckbox checked={check.zone_3} onClick={() => useCheck({ ...check, zone_3: !check.zone_3 })} />
                <PopUpText onClick={() => useCheck({ ...check, zone_3: !check.zone_3 })}>Medical</PopUpText>
                <Oval size={'16'} color={'medical'} />
              </CheckBoxWrapper>
            )}
          </>
        )}
      </SortPopUp>
    );
  } else {
    return <></>;
  }
}

export default ({ dataTableContent }: { dataTableContent: Array<any> }) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [popUp, usePopup] = useState<string>('');
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(true);
  const [tooltipSection, setTooltipSection] = useState<any>([ArmStrength, 'totalStrength']);
  const tooltipRef = useRef<HTMLInputElement | any>(document.createElement('div'));
  const UTILS = new Utils();

  useEffect(() => {
    useTable(dataTableContent);
  }, [dataTableContent]);

  useEffect(() => {
    toggleSortDate('date', ['date'])
  }, [])

  function changeTable(e) {
    useTable([...e]);
  }
  function togglePopUp(selectedPopUp: string) {
    if (selectedPopUp === popUp) {
      usePopup('');
    } else {
      usePopup(selectedPopUp);
    }
  }

  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortDate(params, sortOptions);
  }

  function closeSorts() {
    usePopup('');
    useSort('');
  }

  function sortingTableHead(title: string = '', attr: string, location: Array<any>, sortFunction) {
    return (
      <StickyTableHeadDate topPosition="64px" topPositionResponsive="41px" onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickyTableHeadDate>
    );
  }

  function hoverOval(event, tooltipInfo) {
    let top = Number(event.clientY) + 10;
    let left = Number(event.clientX) + 10;
    if (Number(window.innerWidth) - Number(event.clientX) < 200) {
      left = Number(event.clientX) - 200;
    }
    if (Number(window.innerHeight) - Number(event.clientY) < 180) {
      top = Number(event.clientY) - 150;
    }
    tooltipRef.current.style.display = 'block';
    tooltipRef.current.style.inset = top + 'px 0px 0px ' + left + 'px';
    setTooltipSection(tooltipInfo);
  }

  function hideTooltip() {
    tooltipRef.current.style.display = 'none';
  }

  return (
    <>
      <TableUnit mBottom={'40px'} minWidth={'1360px'}>
        <TableHead>
          <TableRow>
            <TableTopHeader hide={true} colSpan={1} sticky={3}></TableTopHeader>
            <TableTopHeader colSpan={9} sticky={3}>
              STRENGTH
            </TableTopHeader>
            <TableTopHeader colSpan={8} sticky={3}>
              RECOVERY
            </TableTopHeader>
          </TableRow>
          <TableRow>
            <TableHeader colSpan={1}></TableHeader>
            <TableHeader colSpan={5} fontWeight={'normal'}>
              Arm Strength (%BW)
            </TableHeader>
            <TableHeader colSpan={1} fontWeight={'normal'}>
              Shoulder Balance
            </TableHeader>
            <TableHeader colSpan={3} fontWeight={'normal'}>
              Strength Velocity Ratio
            </TableHeader>

            <TableHeader colSpan={6}>
              Arm Recovery - <TableTopHeaderSub>{'Change from average (lbs.)'}</TableTopHeaderSub>
            </TableHeader>
          </TableRow>
          <TableRow>
            {sortingTableHead('Fresh Exam Date', 'date', ['armStrength', 'date'], toggleSortDate)}
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_1')}>Arm Score</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armStrength', 'totalStrength']}
                popup_id={'pu_1'}
                visible={popUp}
                includeAlerts={true}
                status={['armStrength', 'fatigueTotal']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_2')}>IR</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armStrength', 'internalRotation']}
                popup_id={'pu_2'}
                visible={popUp}
                includeAlerts={true}
                status={['armStrength', 'fatigueIR']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_3')}>ER</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armStrength', 'externalRotation']}
                popup_id={'pu_3'}
                visible={popUp}
                includeAlerts={true}
                status={['armStrength', 'fatigueER']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_4')}>Scaption</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armStrength', 'scaption']}
                popup_id={'pu_4'}
                visible={popUp}
                includeAlerts={true}
                status={['armStrength', 'fatigueScaption']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_5')}>Grip</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armStrength', 'grip']}
                popup_id={'pu_5'}
                visible={popUp}
                includeAlerts={true}
                status={['armStrength', 'fatigueGrip']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_6')}>ER:IR Ratio</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['shoulderBalance', 'erIrRatio']}
                popup_id={'pu_6'}
                visible={popUp}
                includeAlerts={true}
                status={['shoulderBalance', 'erIrFatigue']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_7')}>SVR</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['strengthVelocityRatio', 'svr']}
                popup_id={'pu_7'}
                visible={popUp}
                includeAlerts={true}
                status={['strengthVelocityRatio', 'svrFatigue']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span> Total Strength </span>
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span> Max Velocity </span>
            </TableSubHeader>

            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_9')}>Total Recovery</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armRecovery', 'totalStrength']}
                popup_id={'pu_9'}
                visible={popUp}
                includeAlerts={true}
                status={['armRecovery', 'fatigueTotal']}
                medical={true}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_10')}>IR</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armRecovery', 'internalRotation']}
                popup_id={'pu_10'}
                visible={popUp}
                includeAlerts={true}
                status={['armRecovery', 'fatigueIR']}
                medical={true}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_11')}>ER</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armRecovery', 'externalRotation']}
                popup_id={'pu_11'}
                visible={popUp}
                includeAlerts={true}
                status={['armRecovery', 'fatigueER']}
                medical={true}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_12')}>Scaption</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armRecovery', 'scaption']}
                popup_id={'pu_12'}
                visible={popUp}
                includeAlerts={true}
                status={['armRecovery', 'fatigueScaption']}
                medical={true}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_13')}>Grip</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armRecovery', 'grip']}
                popup_id={'pu_13'}
                visible={popUp}
                includeAlerts={true}
                status={['armRecovery', 'fatigueGrip']}
                medical={true}
              />
            </TableSubHeader>
          </TableRow>
        </TableHead>
        <TableBody onClick={() => closeSorts()}>
          {table.length > 0 ? (
            <>
              {table.map((item, index) => {
                return (
                  <TableItem item={item} key={index} hoverInfo={hoverOval} hideTooltip={hideTooltip} />
                );
              })}
            </>
          ) : (
            <TableRow>
              <TableColumn colSpan={20}>No data</TableColumn>
            </TableRow>
          )}
        </TableBody>
      </TableUnit>
      <TooltipFatigueZones section={tooltipSection} tooltipRef={tooltipRef} />
    </>
  );
};

const TableItem = ({ item, hoverInfo, hideTooltip }) => {
  return (
    <TableRow>
      <TableColumn bgColor={'white'}>{handleDate(item.armStrength.date)}</TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.armStrength.totalStrength, { digits: 0 })}
        {getFatigueZoneBullet(item.armStrength.fatigueTotal, [hoverInfo, [ArmStrength, 'totalStrength', 'Total Strength'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.armStrength.internalRotation, { digits: 0 })}
        {getFatigueZoneBullet(item.armStrength.fatigueIR, [hoverInfo, [ArmStrength, 'iR', 'Internal Rotation'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.armStrength.externalRotation, { digits: 0 })}
        {getFatigueZoneBullet(item.armStrength.fatigueER, [hoverInfo, [ArmStrength, 'eR', 'External Rotation'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.armStrength.scaption, { digits: 0 })}
        {getFatigueZoneBullet(item.armStrength.fatigueScaption, [hoverInfo, [ArmStrength, 'scaption', 'Scaption'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.armStrength.grip, { digits: 0 })}
        {getFatigueZoneBullet(item.armStrength.fatigueGrip, [hoverInfo, [ArmStrength, 'grip', 'Grip'], hideTooltip])}
      </TableColumn>
      <TableColumn bgColor={'white'}>
        {numberColumnFormatter(item.shoulderBalance.erIrRatio, { digits: 2 })}
        {getFatigueZoneBullet(item.shoulderBalance.erIrFatigue, [
          hoverInfo,
          [ShoulderBalance, 'shoulderBalance', 'Shoulder Balance'],
          hideTooltip,
        ])}
      </TableColumn>

      <TableColumn>
        {numberColumnFormatter(item.strengthVelocityRatio.svr, { digits: 2 })}
        {getFatigueZoneBullet(item.strengthVelocityRatio.svrFatigue, [
          hoverInfo,
          [StrengthVelocityRatio, 'velocity', 'Velocity'],
          hideTooltip,
        ])}
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.strengthVelocityRatio.totalStrength, { digits: 1 })}
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.strengthVelocityRatio.velocity, { digits: 0})}
      </TableColumn>

      <TableColumn>
        {numberColumnFormatter(item.armRecovery.totalStrength, { digits: 1 })}
        {getFatigueZoneBullet(item.armRecovery.fatigueTotal, [hoverInfo, [ArmRecovery, 'totalStrength', 'Total Strength'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.armRecovery.internalRotation, { digits: 1 })}
        {getFatigueZoneBullet(item.armRecovery.fatigueIR, [hoverInfo, [ArmRecovery, 'iR', 'Internal Rotation'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.armRecovery.externalRotation, { digits: 1 })}
        {getFatigueZoneBullet(item.armRecovery.fatigueER, [hoverInfo, [ArmRecovery, 'eR', 'External Rotation'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.armRecovery.scaption, { digits: 1 })}
        {getFatigueZoneBullet(item.armRecovery.fatigueScaption, [hoverInfo, [ArmRecovery, 'scaption', 'Scaption'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.armRecovery.grip, { digits: 1 })}
        {getFatigueZoneBullet(item.armRecovery.fatigueGrip, [hoverInfo, [ArmRecovery, 'grip', 'Grip'], hideTooltip])}
      </TableColumn>
    </TableRow>
  );
};
